import { ProductRepository } from '../../repositories/ProductRepository';
import { IQueryTypeFragments, QueryFragments } from '../../../api/QueryFragments';
import { Product } from '../entities/Product';
import { IProductFullConfig } from '../../interfaces/IProductFull';
import { IFeatures } from '~constants/Features';
import { IProductDataOptions, IProductDataParams } from '~api/interfaces/IProductDataOptions';

export class ProductFullService {
    public productRepository: ProductRepository;
    private queryFragments: QueryFragments;

    constructor(productRepository: ProductRepository, queryFragments: QueryFragments) {
        this.productRepository = productRepository;
        this.queryFragments = queryFragments;
    }

    public getProductData = async (
        options: IProductDataOptions,
        queryFragments?: IQueryTypeFragments
    ) => {
        return this.productRepository.getProductData(options, queryFragments) as Promise<Product>;
    };

    // @todo remove on MPPFIND-4454
    public getProductByFullConfig = async (config: IProductFullConfig): Promise<Product> => {
        const { features, productId } = config;

        this.queryFragments.setFeatures(<IFeatures>features);

        return this.productRepository.retrieveProductById(
            productId,
            false,
            this.queryFragments.queryFragments
        );
    };

    public getProductFullDataParams = (config: IProductFullConfig): IProductDataParams => {
        const { features, productId } = config;

        this.queryFragments.setFeatures(<IFeatures>features);
        const queryFragments = this.queryFragments.queryFragments;

        return {
            options: {
                filterBy: {
                    productIds: [productId]
                },
                productFullConfig: config,
                updateInventories: true
            },
            queryFragments
        };
    };
}
